<div class="image" [ngClass]="isImageDownloading() ? 'download' : 'upload'" fxLayoutAlign="center">
  <img
    appLoadTechnicalDatasheetImage
    alt="{{ 'TECHNICAL_DATASHEETS.DATASHEET_ALT' | bmsTranslate }}"
    [technicalDatasheetId]="technicalDatasheetId"
    [shouldDownloadImage]="shouldDownloadImage"
    (imageDownloaded)="onImageDownloaded($event)"
    draggable="false"
  />
</div>
